var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{staticStyle:{"width":"100%"},attrs:{"size":"mini","clearable":true,"options":_vm.dataList,"props":_vm.options},model:{value:(_vm.currentVal),callback:function ($$v) {_vm.currentVal=$$v},expression:"currentVal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }